<template>
  <!-- The merchant or store has explicitly disabled ordering for the current ordering flow -->
  <cf-page-banner v-if="!selectedLocation.isCurrentServiceAvailable">
    {{ orderingUnavailbleContent }}
  </cf-page-banner>

  <!-- The selected location is too far away from the user's current location -->
  <cf-page-banner v-else-if="selectedLocation.outsideGeoFence">
    {{ selectedLocation.outsideGeoFenceErrorModel.message }}
  </cf-page-banner>

  <cf-page-banner v-else-if="selectedLocation.outsideGeoFenceWarning">
    {{ selectedLocation.outsideGeoFenceWarningErrorModel.message }}
  </cf-page-banner>

  <!-- The selected location supports ordering, but not at the current time based on the store schedule -->
  <cf-page-banner v-else-if="!selectedLocation.isReadyForOrdering">
    <template v-if="selectedLocation.nextOpening">
      This store is currently closed and will begin accepting orders again
      {{ $momentCalendar(selectedLocation.nextOpening.openTimestamp, null, selectedLocation.timeZone) }} – {{ $timeOfDay(selectedLocation.nextOpening.closeTime, true) }}
    </template>

    <template v-else>
      {{ orderingUnavailbleContent }}
    </template>
  </cf-page-banner>

  <cf-page-banner v-else-if="menu.unavailablePerSchedule">
    <template v-if="menuSchedule.nextAvailable">
      This menu is currently unavailable for ordering. Ordering will be available

      <template v-if="menuSchedule.nextAvailable.hasSpecialHours">
        {{ $momentCalendar(menuSchedule.nextAvailable.startTimestamp, null, selectedLocation.timeZone) }} – {{ $timeOfDay(menuSchedule.nextAvailable.endTime, true) }}.
      </template>

      <template v-else-if="selectedLocation.nextOpening">
        {{ $momentCalendar(selectedLocation.nextOpening.openTimestamp, null, selectedLocation.timeZone) }} – {{ $timeOfDay(selectedLocation.nextOpening.closeTime, true) }}.
      </template>
    </template>

    <template v-else>This menu is currently unavailable for ordering. Please check back again later.</template>
  </cf-page-banner>

  <!-- TODO: Confirm with QA how this works -->
  <!-- <cf-current-day-menu-schedule
    v-else
    :schedule="menu.schedule"
  >
    <template #default="{ notAvailable, schedule }">
      <cf-page-banner>
        <template #override-default-slot>
          <span class="cf-icon fa-clock far" />

          <p
            v-if="notAvailable"
            class="cf-page-banner__content"
          >
            {{ menuTypeDisplay }} ordering is not available today, but you can order for a different day.
          </p>

          <p
            v-else
            class="cf-page-banner__content"
          >
            {{ menuTypeDisplay }} ordering is available today from {{ schedule }}.
          </p>
        </template>
      </cf-page-banner>
    </template>
  </cf-current-day-menu-schedule> -->
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfPageBanner from '@/view/components/shared/cf-page-banner/index.vue';
  // import CfCurrentDayMenuSchedule from '@/view/components/globals/cf-current-day-menu-schedule/index.vue';


  export default {
    name: 'CfLocationStatusPageBanner',

    components: {
      CfPageBanner
      // CfCurrentDayMenuSchedule
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('locations', ['selectedLocation']),
      ...mapGetters('menu', ['menu', 'menuSchedule', 'menuTypeDisplay']),

      orderingUnavailbleContent() {
        return this.content.DisableOnlineOrdering.description;
      }
    }
  };
</script>
